var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"tr-radio",class:{
		'is-checked': _vm.checked,
		'is-disabled': _vm.disabled,
	}},[_c('input',{staticClass:"tr-radio__radio",attrs:{"type":"radio","disabled":_vm.disabled},domProps:{"value":_vm.value,"checked":_vm.checked},on:{"change":function($event){return _vm.$emit('click')}}}),_c('div',{staticClass:"tr-radio__style",class:{
			'tr-radio__style--selected': _vm.checked,
		}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }